import React from 'react';
import { Form, Input } from 'antd';

const AdminUniqueId: React.FC = () => {
  return (
    <Form.Item
      name="code"
      label="Unique ID"
      rules={[{ message: 'Please enter the unique ID!' }]}
    >
      <Input />
    </Form.Item>
  );
};

export default AdminUniqueId;
